import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { action } from 'src/app/interfaces/action';
import { flowData } from 'src/app/interfaces/flowData';
import { DialogService } from 'src/app/services/dialog.service';
import { FlowModalComponent } from 'src/app/forms/flow-action/flowaction.component';
import { FormulaServices } from 'src/app/services/formula.service';
import { Variable } from 'src/app/forms/formula-tester/formula-tester.component';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

const MOCK_PEDIDOS = [
  { PEDIDO: 'MLA-100001', CLIENTE: 'Joao Silva',      MARKETPLACE: 'Mercado Livre', VALOR: 299.90,  STATUS: 'Pendente'  },
  { PEDIDO: 'AMZ-200043', CLIENTE: 'Maria Santos',    MARKETPLACE: 'Amazon',        VALOR: 149.50,  STATUS: 'Pago'      },
  { PEDIDO: 'SHP-305021', CLIENTE: 'Pedro Costa',     MARKETPLACE: 'Shopee',        VALOR: 89.90,   STATUS: 'Enviado'   },
  { PEDIDO: 'MLA-100072', CLIENTE: 'Ana Lima',        MARKETPLACE: 'Mercado Livre', VALOR: 450.00,  STATUS: 'Entregue'  },
  { PEDIDO: 'MGL-400099', CLIENTE: 'Carlos Ferreira', MARKETPLACE: 'Magalu',        VALOR: 1299.99, STATUS: 'Cancelado' },
  { PEDIDO: 'SHP-305099', CLIENTE: 'Lucia Mendes',    MARKETPLACE: 'Shopee',        VALOR: 67.50,   STATUS: 'Pendente'  },
];

@Component({
  selector: 'app-demo-acoes',
  templateUrl: './demo-acoes.component.html',
  styleUrls: ['./demo-acoes.component.scss'],
  standalone: false,
})
export class DemoAcoesComponent implements OnInit {
  displayedColumns = ['select', 'PEDIDO', 'CLIENTE', 'MARKETPLACE', 'VALOR', 'STATUS'];
  dataSource = new MatTableDataSource(MOCK_PEDIDOS);
  selection = new SelectionModel<any>(true, []);

  configFN = { expression: "concatenar(PEDIDO, ' - ', CLIENTE)" };
  configC  = { idConf: null as number | null, codecompany: null as number | null };
  configNM = { idConf: null as number | null, codecompany: null as number | null, contextoAcao: 'EXECUTAR' };

  executingFN = false;

  constructor(
    private dialogService: DialogService,
    private formulaService: FormulaServices,
    private snackBar: SnackbarService,
    public uas: UserAuthenticationServices,
  ) {}

  ngOnInit(): void {
    const cc = Number((this.uas.user as any)?.companylist?.[0]?.codecompany ?? 1);
    this.configC.codecompany = cc;
    this.configNM.codecompany = cc;
  }

  get selected(): any[] { return this.selection.selected; }

  isAllSelected(): boolean {
    return this.selection.selected.length === this.dataSource.data.length;
  }

  isSomeSelected(): boolean {
    const s = this.selection.selected.length;
    return s > 0 && s < this.dataSource.data.length;
  }

  toggleAll(): void {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => this.selection.select(row));
    }
  }

  toggleRow(row: any): void { this.selection.toggle(row); }
  isSelected(row: any): boolean { return this.selection.isSelected(row); }

  executarFN(): void {
    if (!this.selected.length) { this.snackBar.showError('Selecione ao menos uma linha.'); return; }
    if (!this.configFN.expression?.trim()) { this.snackBar.showError('Informe a expressao.'); return; }

    const vars: Variable[] = [
      { key: '__rows', value: JSON.stringify(this.selected), type: 'TEXTO' },
    ];
    Object.keys(this.selected[0]).forEach(k => {
      vars.push({ key: k, value: String((this.selected[0] as any)[k] ?? ''), type: 'TEXTO' });
    });

    this.executingFN = true;
    this.formulaService.executeFormula(this.configFN.expression, vars, true)
      .then((resultado: any) => { this.snackBar.showSuccess('Resultado: ' + resultado); })
      .catch((err: any)     => { this.snackBar.showError('Erro na formula: ' + (err?.message ?? err)); })
      .finally(()           => { this.executingFN = false; });
  }

  executarC(): void {
    if (!this.selected.length) { this.snackBar.showError('Selecione ao menos uma linha.'); return; }
    if (!this.configC.idConf)  { this.snackBar.showError('Informe o IDCONF.'); return; }

    const act: action = {
      NAME: 'Demo - Fluxo Antigo', ICON: 'settings_backup_restore',
      IDCONF: String(this.configC.idConf),
      CODECOMPANY: String(this.configC.codecompany ?? 1),
      TYPE: 'C',
      EXPRESSION: JSON.stringify({ idConf: this.configC.idConf, codeCompany: this.configC.codecompany, showCodeCompany: false }),
      SELECTED: null, IDINSTANCE: 0, IDACTION: 0, PARAMETERS: [],
    };
    const fd: flowData = { action: act, selected: this.selected, function: null, parameters: null };
    this.dialogService.openGenericDialog(FlowModalComponent, fd, () => {}, () => {}, '80vh', '80vw', true, null, 'S', '30px');
  }

  executarNM(): void {
    if (!this.selected.length) { this.snackBar.showError('Selecione ao menos uma linha.'); return; }
    if (!this.configNM.idConf) { this.snackBar.showError('Informe o IDCONF.'); return; }

    const act: action = {
      NAME: 'Demo - Fluxo Novo', ICON: 'rocket_launch',
      IDCONF: String(this.configNM.idConf),
      CODECOMPANY: String(this.configNM.codecompany ?? 1),
      TYPE: 'NM',
      EXPRESSION: JSON.stringify({ idConf: this.configNM.idConf, codeCompany: this.configNM.codecompany, showCodeCompany: false, contextoAcao: this.configNM.contextoAcao }),
      SELECTED: null, IDINSTANCE: 0, IDACTION: 0, PARAMETERS: [],
    };
    const fd: flowData = { action: act, selected: this.selected, function: null, parameters: null };
    this.dialogService.openGenericDialog(FlowModalComponent, fd, () => {}, () => {}, '80vh', '80vw', true, null, 'S', '30px');
  }
}
